// (C) Copyright 2025 Hewlett Packard Enterprise Development LP

export const ssoModeEnum = Object.freeze({
  AUTHENTICATION_ONLY: 'authentication-only',
  AUTHORIZATION: 'authorization',
  AUTHENTICATION_ONLY_MSP_MANAGED_TENANT_ONLY:
    'authentication-only-msp-managed-tenant-only',
  AUTHORIZATION_MSP_MANAGED_TENANT_ONLY:
    'authorization-msp-managed-tenant-only',
  AUTHENTICATION_ONLY_MSP_MANAGED: 'authentication-only-msp-managed',
  AUTHORIZATION_MSP_MANAGED: 'authorization-msp-managed'
})

export const AuthorizationOption = Object.freeze({
  local: 'LOCAL',
  sso: 'SSO'
})

export const IdpConfig = Object.freeze({
  oidcConfig: 'oidcIdpConfig',
  samlConfig: 'samlIdpConfig'
})

export const Authnoptions = Object.freeze({
  SAML: 'Saml',
  OIDC: 'OIDC'
})

export const oidcauthorization = Object.freeze({
  LOCAL: 'LRA',
  SSO: 'SRA'
})

export const dispositionEnum = Object.freeze({
  LEAST_SECURE: 'least-secure',
  MOST_SECURE: 'most-secure'
})

export const authorizationEnum = Object.freeze({
  LOCAL: 'Local',
  SAML: 'SAML'
})

export const mspOptions = Object.freeze({
  mspOrg: 'MSP-organization',
  custOrg: 'customer-organizations'
})
export const idpConfigOptions = Object.freeze({
  UPLOAD_FROM_FILE: 'Upload a metadata XML file',
  SPECIFY_URL: 'Specify a metadata URL',
  MANUAL: 'Manual entry of configuration details'
})

export const getAuthorizationText = (status) => {
  let text = ''
  switch (status) {
    case ssoModeEnum?.AUTHENTICATION_ONLY:
      text = authorizationEnum.LOCAL
      break
    case ssoModeEnum?.AUTHORIZATION:
      text = authorizationEnum.SAML
      break
    default:
      break
  }
  return text
}
export const getAuthentication = (value) => {
  let text = ''
  switch (value) {
    case 'Saml':
      text = 'SAML 2.0'
      return text
    case 'OIDC':
      text = 'OIDC'
      return text
    default:
      break
  }
  return text
}

export const getAuthorizationTextLD = (status) => {
  let text = ''
  switch (status) {
    case ssoModeEnum?.AUTHENTICATION_ONLY:
      text = authorizationEnum.LOCAL
      break
    case ssoModeEnum?.AUTHORIZATION:
      text = authorizationEnum.SAML
      break
    case ssoModeEnum?.AUTHENTICATION_ONLY_MSP_MANAGED:
      text = authorizationEnum.LOCAL
      break
    case ssoModeEnum?.AUTHORIZATION_MSP_MANAGED:
      text = authorizationEnum.SAML
      break
    case ssoModeEnum?.AUTHORIZATION_MSP_MANAGED_TENANT_ONLY:
      text = authorizationEnum.SAML
      break
    case ssoModeEnum?.AUTHENTICATION_ONLY_MSP_MANAGED_TENANT_ONLY:
      text = authorizationEnum.LOCAL
      break
    default:
      break
  }
  return text
}

export const generateRedirectUrl = (value) => {
  if (value) {
    const escapedJsonString = `{"iss":"${value.replace(/\//g, '\\/')}"}`
    // Encode the JSON string into Base64 and make it URL-safe
    const base64 = btoa(escapedJsonString)
    const replaceString = { '+': '-', '/': '_' }
    const base64url = []
    Array.from(base64).forEach((char) => {
      if (char !== '=') {
        base64url.push(replaceString[char] ?? char)
      }
    })
    // Construct the redirect URL
    const url = `https://sso.common.cloud.hpe.com/sp/${base64url.join(
      ''
    )}/cb.openid`
    // Set the redirect URL
    return url
  }
  return null
}

export const idp = Object.freeze({
  entityIdUrl: 'https://sso.common.cloud.hpe.com',
  acsUrl: 'https://sso.common.cloud.hpe.com/sp/ACS.saml2',
  defaultRelayStateUrl: 'https://common.cloud.hpe.com'
})
